export const getAdelaideHillsData = () => ({
  name: "Adelaide Hills",
  country: "Australie",
  description: "Les Adelaide Hills sont une région viticole de climat frais en Australie-Méridionale, réputée pour ses Chardonnay élégants et ses Pinot Noir complexes. Son altitude élevée et son climat tempéré créent des conditions idéales pour des vins de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Adelaide Hills", x: 43, y: 78, color: "#f0e0f0", size: 3 }
  ],
  statistics: {
    totalArea: "4,000 ha",
    production: "0.25 million hectolitres",
    appellations: "Adelaide Hills GI",
    subregions: "3 sous-régions principales",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat tempéré avec altitude élevée, étés chauds, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Shiraz frais, Cabernet Sauvignon structurés",
    white: "Chardonnay élégants et complexes, Sauvignon Blanc aromatiques, Riesling frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "La viticulture dans les Adelaide Hills a débuté dans les années 1970. La région s'est rapidement imposée comme l'une des plus prestigieuses d'Australie pour les vins de climat frais, reconnue pour ses Chardonnay et Pinot Noir.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  subregions: {
    "lenswood": {
      name: "Lenswood",
      description: "Zone d'altitude, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes.",
      characteristics: {
        climate: "Frais, altitude élevée",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vignobles modernes, altitude élevée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "pinot-noir": "Rouges élégants et complexes",
        "chardonnay": "Blancs frais et aromatiques"
      },
      foodPairing: "Poissons, volailles, fromages affinés"
    },
    "piccadilly-valley": {
      name: "Piccadilly Valley",
      description: "Zone historique, connue pour ses vins blancs frais et ses rouges élégants.",
      characteristics: {
        climate: "Tempéré, influence océanique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles historiques, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et aromatiques",
        "rouge": "Rouges élégants et équilibrés"
      },
      foodPairing: "Fruits de mer, poissons, cuisine traditionnelle"
    },
    "kuitpo": {
      name: "Kuitpo",
      description: "Zone méridionale, réputée pour ses vins rouges structurés et ses blancs complexes.",
      characteristics: {
        climate: "Tempéré, influence océanique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles modernes, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    }
  }
}); 